import TracksPage from "./VideosPage";

export default TracksPage;